import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, TextField } from "@mui/material";
import React from "react";
import { ErrorData } from "../config/interfaces";

interface IIconButton {
  showPassword: boolean;
  setShowPassword: React.Dispatch<React.SetStateAction<boolean>>;
}

interface ITextField extends IIconButton {
  passwordCheck: ErrorData;
  type?: string;
}

const PasswordIconButton = ({ showPassword, setShowPassword }: IIconButton) => (
  <IconButton
    sx={{
      border: 0,
      background: "none",
      height: "90%",
    }}
    onClick={() => setShowPassword((show) => !show)}
    onMouseDown={(event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
    }}
    onMouseUp={(event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
    }}
    edge="end">
    {showPassword ? <VisibilityOff /> : <Visibility />}
  </IconButton>
);

export const PasswordTextField = ({
  passwordCheck,
  showPassword,
  setShowPassword,
  type,
}: ITextField) => {
  return (
    <TextField
      name={type ? type : "password"}
      placeholder="•••••••••"
      type={showPassword ? "text" : "password"}
      id={type ? type : "password"}
      autoComplete="current-password"
      required
      fullWidth
      variant="outlined"
      error={passwordCheck.error}
      helperText={passwordCheck.message}
      color={passwordCheck.error ? "error" : "primary"}
      slotProps={{
        input: {
          endAdornment: (
            <PasswordIconButton
              showPassword={showPassword}
              setShowPassword={setShowPassword}
            />
          ),
        },
      }}
    />
  );
};
